module.exports = __webpack_public_path__ + "img/studentenwohnheimvallendar_1.db2636e8.jpg";